import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * LangSwitcher — EN | ગુ pill toggle
 * Switches between English and Gujarati.
 * Persists selection to localStorage via i18n's languageChanged event (wired in src/i18n/index.js).
 */
const LangSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const current = i18n.language;

  const switchTo = (lng) => {
    if (lng !== current) {
      i18n.changeLanguage(lng);
    }
  };

  return (
    <div className={`lang-switcher ${className}`} role="group" aria-label="Select language">
      <button
        className={`lang-switcher__btn${current === 'en' ? ' lang-switcher__btn--active' : ''}`}
        onClick={() => switchTo('en')}
        aria-pressed={current === 'en'}
        title="English"
      >
        EN
      </button>
      <span className="lang-switcher__divider" aria-hidden="true">|</span>
      <button
        className={`lang-switcher__btn${current === 'gu' ? ' lang-switcher__btn--active' : ''}`}
        onClick={() => switchTo('gu')}
        aria-pressed={current === 'gu'}
        title="ગુજરાતી"
      >
        ગુજ
      </button>
    </div>
  );
};

export default LangSwitcher;
